





















































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class DataQualityHelp extends Vue {
  tab = null;
}
